var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.533,
    height: 164.029,
    viewBox: "0 0 191.533 164.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20073",
    "data-name": "Group 20073",
    transform: "translate(-24.086 -37.899)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44027",
    "data-name": "Path 44027",
    d: "M59.683,171.029c24.365-.837,124.339-3.256,141.56-10.321,20.6-8.452,11.016-69.863,8.1-92.729-1.165-9.124-5.659-20.8-14.547-25.353C179.326,34.7,50.645,43.814,38.85,48.344c-17.964,6.9-12.759,30.392-12.308,42.549.646,17.426,1.549,34.905,2.739,52.3.589,8.606.461,17.371,7.477,23.438,6.345,5.488,15.309,4.656,22.926,4.394Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44028",
    "data-name": "Path 44028",
    d: "M99.325,169.707c14.172-.534,30.049-1.23,45.063-2.138,2.036,8.491,2.483,17.758,2.839,25.131.063,1.3.123,2.543.188,3.711-6.582.414-14.938.818-23.756,1.244-8.3.4-17.007.821-25.03,1.289v-2.575c-.007-1.109-.029-2.354-.053-3.707A166.9,166.9,0,0,1,99.325,169.707Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44029",
    "data-name": "Path 44029",
    d: "M78,200.3c6.666-.592,13.58-1.084,20.611-1.513m77.51-4.125c-8.911.7-18.631,1.234-28.746,1.722",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44030",
    "data-name": "Path 44030",
    d: "M63.688,117.435C75.173,106.757,84.171,93.2,96.4,83.231c5.679,6.615,12.314,12.456,17.349,19.64,7.19-3.468,38.559-32.422,45.694-39.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44031",
    "data-name": "Path 44031",
    d: "M73.348,128.725c.253,4.673.282,9.367.681,14.03",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44032",
    "data-name": "Path 44032",
    d: "M92.954,113.383c-.1,9.506.943,18.954,1.794,28.4",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44033",
    "data-name": "Path 44033",
    d: "M114.006,123.621c.36,6.122,1.008,12.311,1.671,18.415",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44034",
    "data-name": "Path 44034",
    d: "M137.336,110.853c1.788,9.465,1.705,19.1,2.926,28.607",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44035",
    "data-name": "Path 44035",
    d: "M161.375,138.724c-1.275-6.408-.685-13.444-1.066-19.941-.627-10.68-2.209-21.534-2.054-32.226",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.a6ac5a38695f007d8cad88c12992e383.svg";
export { ForwardRef as ReactComponent };